
import {Component, Vue} from 'vue-property-decorator';
import {AuthStore} from '@/store/modules/Auth';
import {subscriptionLabels, subscriptionDate} from '@/UI/lib/support';
@Component
export default class CompanySubscription extends Vue {
  labels = subscriptionLabels;
  timer = 0;
  get subscription(): any { return AuthStore.companySubscription; }
  get owner(): boolean { return Vue.auth.check('owner') || Vue.auth.check('admin'); }
  date(value: string): string { return subscriptionDate(value, this.$i18n.locale); }
  async refresh(): Promise<void> {
    if (document.hidden) return;
    try { await AuthStore.loadCompanySubscription(); } catch (error) { /* Existing API error handling remains in effect. */ }
  }
  mounted(): void {
    this.refresh();
    this.timer = window.setInterval(() => this.refresh(), 60000);
    window.addEventListener('focus', this.refresh);
    window.addEventListener('pult-subscription-changed', this.refresh);
  }
  beforeDestroy(): void {
    window.clearInterval(this.timer);
    window.removeEventListener('focus', this.refresh);
    window.removeEventListener('pult-subscription-changed', this.refresh);
  }
}
